module.exports = __webpack_public_path__ + "static/media/17.7f580de2.jpg";